<template>
  <div style="max-width: 600px; min-height: 99vh" class="mx-auto bg-white">
    <div class="d-flex align-items-center flex-column justify-content-center">
      <div class="d-flex justify-content-between">
        <div class="img-container">
          <b-img
            class="mx-auto mt-1 img-logo"
            style="height: 100px"
            :src="require('@/assets/images/logo/MinistryLogo.png')"
          />

        </div>
        <div class="img-container">
          <b-img
            class="mx-auto mt-1 img-logo"
            style="height: 100px"
            :src="require('@/assets/images/logo/header-logo.png')"
          />

        </div>
        

      </div>
      <!-- <b-button @click="onBackClick" variant="info">
        <feather-icon size="16" icon="ArrowLeftIcon" class="mr-50" />
        عودة
      </b-button> -->
      <hr class="w-100" />
      <b-skeleton-wrapper style="width: 100%" :loading="loading">
        <div v-if="error" class="err-text">{{ errorText }}</div>
        <div v-else class="info-container">
          <div class="d-flex justify-content-center">
            <b-img
              class="mx-auto"
              style="height: 180px"
              :src="data.logo"
              alt="شعار المنظمة"
            />
          </div>
          <h2>{{ data.name_ar }}</h2>
          <b-alert :show="showAlert" variant="danger" class="my-3">
            <div class="alert-body d-flex align-items-center h5 text-danger">
              <feather-icon icon="InfoIcon" class="mr-50 mt-25" />
              <div>{{ alertText }}</div>
            </div>
          </b-alert>
          <template v-if="!isQrSuspended">
            <div>
              <span> حالة المنظمة </span>
              <h4 :class="{ 'text-danger': isNgoInactive }">
                {{ data.status ? data.status.name_ar : "" }}
              </h4>
            </div>
            <div>
              <span> رقم قرار الإشهار </span>
              <h4>
                {{ data.decision_no }}
              </h4>
            </div>
            <div>
              <span> تاريخ قرار الإشهار </span>
              <h4>
                {{ data.decision_date }}
              </h4>
            </div>
            <div>
              <span> الشكل القانوني </span>
              <h4>{{ data.legalForm ? data.legalForm.name_ar : "" }}</h4>
            </div>
            <div>
              <span> تمتلك صفة النفع العام </span>
              <h4>{{ data.has_public_benefit ? "نعم" : "لا" }}</h4>
            </div>
            <div>
              <span> الأهداف </span>
              <h4>{{ data.objectives }}</h4>
            </div>
            <!-- <div>
              <span> التصنيف </span>
              <ul>
                <li
                  style="font-size: 12pt"
                  class="my-50"
                  v-for="classification in data.classifications"
                  :key="classification.id"
                >
                  {{ classification.name_ar }}
                </li>
              </ul>
            </div> -->
            <div>
              <span> المقر الرئيسي </span>
              <h4>{{ data.mainHQ ? data.mainHQ.governorate.name_ar : "" }}</h4>
            </div>
            <div>
              <span> يتناول نشاطها </span>
              <h4>
                {{
                  data.governorates
                    ? data.governorates.map((el) => el.name_ar).join(" , ")
                    : ""
                }}
              </h4>
            </div>
            <div>
              <span> الفروع غير المشهرة </span>
              <h4>
                {{
                  data.unKnownBranchsForMediationRequest
                    ? data.unKnownBranchsForMediationRequest.map((el) => el.governorate.name_ar).join(" , ")
                    : ""
                }}
              </h4>
            </div>
            <div>
              <span>
                رئيس مجلس
                {{
                  data.legalForm && data.legalForm.name_ar === "مؤسسة"
                    ? "الأمناء"
                    : "الإدارة"
                }}
              </span>
              <h4>{{ data.administrationCouncilHeadForMediationRequest || "_________" }}</h4>
            </div>
            <div>
              <span> أمين الصندوق </span>
              <h4>{{ data.treasurerForMediationRequest || "_________" }}</h4>
            </div>
          </template>
        </div>
        <template #loading>
          <b-skeleton
            type="avatar"
            no-aspect
            class="mt-1 mx-auto"
            width="150px"
            height="150px"
          />
          <b-skeleton
            class="mx-auto mt-1"
            style="text-align: center"
            width="60%"
          />
          <b-skeleton
            class="mx-auto mt-1"
            style="text-align: center"
            width="40%"
          />
          <div class="mt-5">
            <div class="px-2 mt-3" v-for="n in 5" :key="n">
              <b-skeleton width="25%" />
              <b-skeleton width="75%" />
            </div>
          </div>
        </template>
      </b-skeleton-wrapper>
    </div>
  </div>
</template>

<script>
import { hasError } from "@/utils/utils";
import {
  BImg,
  BSkeletonWrapper,
  BAlert,
  BSkeletonImg,
  BSkeleton,
} from "bootstrap-vue";
import axios from "@axios";
export default {
  components: { BImg, BSkeletonWrapper, BAlert, BSkeletonImg, BSkeleton },

  data() {
    return {
      loading: false,
      error: false,
      errorText: "",
      data: {},
    };
  },

  computed: {
    alertText() {
      return this.isQrSuspended
        ? "رمز ال QR مجمّد !"
        : this.isNgoInactive
        ? "المنظمة خارج الخدمة حالياً"
        : "";
    },
    isNgoInactive() {
      return (
        this.data && this.data.status && this.data.status.name_ar !== "فاعلة"
      );
    },
    isQrSuspended() {
      return !this.loading && this.data && !this.data.legalForm;
    },
    showAlert() {
      return (
        this.isQrSuspended ||
        (this.data && this.data.status && this.data.status.name_ar !== "فاعلة")
      );
    },
  },

  async mounted() {
    this.loading = true;
    try {
      var res = await axios.get("v2/files-qrs/scan-file", {
        params: { QR: this.$route.query.QR },
      });
      if (hasError(res.status)) throw res.data.message;

      this.data = res.data.data;
    } catch (err) {
      this.errorText = err;
      this.error = true;
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.info-container {
  width: 85%;
  h2 {
    margin-bottom: 3rem;
    text-align: center;
  }
  div + div {
    margin-top: 1.5rem;
  }
  div > span {
    color: var(--primary);
  }
  div > h4 {
    margin-top: 0.3rem;
  }
}
.err-text {
  color: var(--danger);
  font-size: 16pt;
  text-align: center;
  margin-top: 3rem;
}
.img-container{
  width: 42%;
  display: flex;
    
}
.img-logo{
  width: 100%;
  height: auto;
  object-fit: scale-down;
}

</style>
